import React, {useEffect, useState} from "react";
import DashboardContent from "../components/Dashboard/DashboardContent/dashboardcontent";
import { Container, Spinner } from "react-bootstrap";

export default function Dashboard() {
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [dev, setDev] = useState(true); //set true if want to edit dashboard, other wise set false
    
    const API_URL = process.env.REACT_APP_API_URL || "";

    useEffect(() => {
            const checkAdminStatus = async () => {
                try {
                    const token = localStorage.getItem('token');
                    
                    if (!token) {
                        setIsAdmin(false);
                        setLoading(false);
                        return;
                    }
    
                    const response = await fetch(`${API_URL}/admin/check-status`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });
    
                    if (response.status === 200) {
                        setIsAdmin(true);
                    } else {
                        setIsAdmin(false);
                    }
                } catch (err) {
                    console.error("Error checking admin status:", err);
                    setError("Failed to verify admin privileges");
                    setIsAdmin(false);
                } finally {
                    setLoading(false);
                }
            };
            if (dev) {
                checkAdminStatus();
            }
            
    }, [API_URL]);

     // Custom styled components for dark mode support
     const containerStyle = {
        minHeight: "60vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "2rem"
    };

    const messageBoxStyle = {
        padding: "2rem",
        backgroundColor: "var(--card-background)",
        color: "var(--text-primary)",
        borderRadius: "0.5rem",
        boxShadow: "0 4px 8px var(--shadow-color)",
        width: "100%",
        maxWidth: "600px",
        textAlign: "center"
    };

    const headingStyle = {
        color: "var(--text-primary)",
        marginBottom: "1rem",
        fontSize: "1.5rem",
        fontWeight: "bold"
    };

    const textStyle = {
        color: "var(--text-secondary)",
        fontSize: "1rem",
        lineHeight: "1.5"
    };

    if (loading && !dev) {
        return (
            <div style={containerStyle}>
                <div style={messageBoxStyle}>
                    <Spinner 
                        animation="border" 
                        style={{ color: "var(--text-primary)" }} 
                    />
                    <p style={{ ...textStyle, marginTop: "1rem" }}>
                        Verifying admin access...
                    </p>
                </div>
            </div>
        );
    }
    
    if (error && !dev) {
        return (
            <div style={containerStyle}>
                <div style={{...messageBoxStyle, borderLeft: "4px solid #dc3545"}}>
                    <h2 style={headingStyle}>Error</h2>
                    <p style={textStyle}>{error}</p>
                </div>
            </div>
        );
    }
    
    if (!isAdmin && !dev) {
        return (
            <div style={containerStyle}>
                <div style={{...messageBoxStyle, borderLeft: "4px solid #ffc107"}}>
                    <h2 style={headingStyle}>Access Denied</h2>
                    <p style={textStyle}>
                        You do not have permission to access the admin panel. 
                        Please contact an administrator if you believe this is an error.
                    </p>
                </div>
            </div>
        );
    }    

    return (
        <div>
            <DashboardContent/>
        </div>
    )
}